<template>
  <footer class="container is-hidden-print">
    <div class="top">
      <div class="columns">
        <div class="column is-one-fifth">
          <img
            class="logo"
            src="@/assets/images/ca.png"
            alt="Logo Casa Administraciones"
          />
          <h3 class="has-text-weight-bold has-text-primary is-size-5">
            Tu propiedad en nuestras manos produce
          </h3>
        </div>
        <div class="column is-one-fifth">
          <span class="has-text-weight-bold has-text-primary">Propiedades</span>
          <ul>
            <li>
              <router-link :to="{ name: 'manage-properties' }">
                Administrar Propiedades
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'rent-buy' }">
                Renta o Compra
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'manage-properties' }">
                Venda su casa
              </router-link>
            </li>
          </ul>
        </div>
        <div class="column is-one-fifth">
          <span class="has-text-weight-bold has-text-primary">Servicios</span>
          <ul>
            <li>
              <router-link :to="{ name: 'experience' }">
                Experencia CA
              </router-link>
            </li>
          </ul>
        </div>
        <div class="column is-one-fifth">
          <span class="has-text-weight-bold has-text-primary">
            Arrendamiento
          </span>
          <ul>
            <li @click="downloadDoc(docType.NUM_NATURAL_APPLICATION)">
              Solicitud persona física
            </li>
            <li @click="downloadDoc(docType.NUM_LEGAL_APPLICATION)">
              Solicitud persona moral
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="middle">
      <div class="columns">
        <div class="column">
          <div class="m-b-sm">Síguenos en</div>
          <a
            target="_blank"
            href="https://www.facebook.com/casaadministraciones/"
            aria-label="Síguenos en Facebook"
          >
            <vue-fontawesome icon="facebook" class="has-text-greyish-blue" />
          </a>
          <a
            target="_blank"
            href="https://www.instagram.com/casaadmons/"
            aria-label="Síguenos en Instragram"
          >
            <img
              class="instagram"
              src="@/assets/images/instagram.png"
              alt="instagram"
            />
          </a>
          <a
            target="_blank"
            href="https://www.linkedin.com/company/casaadministraciones/about"
            aria-label="Síguenos en LinkedIn"
            class="linkedin"
          >
            <vue-fontawesome :icon="['fab', 'linkedin']" size="lg" />
          </a>
          <a
            target="_blank"
            href="https://www.youtube.com/@CasaAdministracionesComercial"
            aria-label="Visítanos en youtube"
            class="youtube"
          >
            <vue-fontawesome :icon="['fab', 'youtube']" size="lg" />
          </a>
        </div>
      </div>
    </div>
    <hr />
    <div class="bottom">
      <div class="level">
        <div class="level-left">
          <div class="level-item has-text-left is-flex-touch">
            <ul class="has-text-weight-bold has-text-primary">
              <li class="is-inline-block-tablet m-r-md">
                <router-link :to="{ name: 'contact' }">
                  Contacto
                </router-link>
              </li>
              <li class="is-inline-block-tablet">
                <router-link :to="{ name: 'jobs' }">
                  <vue-fontawesome
                    icon="portfolio"
                    class="has-text-primary-green"
                  />
                  Bolsa de trabajo
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item is-flex-touch">
            <ul>
              <li>
                <router-link
                  class="has-text-primary has-text-weight-bold"
                  :to="{ name: 'notice-privacy' }"
                >
                  Aviso de privacidad
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column">
          © 2020 CA All rights reserved
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import DocumentType from "@/constants/documents/document-type";
import Documents from "@/services/documents";

export default {
  name: "TheFooter",

  data() {
    return {
      docType: DocumentType
    };
  },

  methods: {
    downloadDoc(type) {
      const filename = DocumentType.get[type];
      Documents.propertyInfoDocument(type)
        .then(res => {
          const contentType = res.headers["content-type"];
          const blob = new Blob([res.data], { type: contentType });

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
          } else {
            const objectUrl = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = objectUrl;
            link.download = filename;

            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
$black: #363636;
$blue: #1a4275;

footer {
  padding: 2em 1em;

  li {
    a {
      color: $black;

      &:hover {
        color: $blue;
      }
    }

    &:hover {
      color: $blue;
      cursor: pointer;
    }
  }

  .logo {
    height: 30px;
  }

  .bottom .level-item {
    justify-content: flex-start;
  }

  .instagram {
    margin-left: 0.8em;
    margin-bottom: -4px;
    width: 1.2em;
  }

  .linkedin {
    margin-left: 0.8em;
    margin-bottom: -4px;
  }

  .youtube {
    margin-left: 0.8em;
    color: #ff0000;
  }
}
</style>
